import { P2GButton, P2GIcon, SvgArrowLinkRight } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
type CTAButtonProps = {
  loading: boolean;
  onClick?: () => void;
  fullWidth: boolean;
  disabled?: boolean;
  labelTranslationKey?: string;
  defaultLabel?: string;
  ref?: React.RefObject<HTMLButtonElement>;
};

export default function CTAButton({
  loading,
  onClick,
  fullWidth,
  labelTranslationKey,
  defaultLabel,
  disabled,
  ref
}: CTAButtonProps) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const labelText = t(labelTranslationKey || 'NEXT_BUTTON', { defaultValue: defaultLabel || 'Next Step' });
  return (
    <P2GButton
      dataTestId="cta-button"
      id="btnNext"
      type={onClick ? 'button' : 'submit'}
      disabled={loading || disabled}
      variant="primary"
      size="large"
      fullWidth={fullWidth}
      onClick={onClick}
      ref={ref}
      endIcon={
        <P2GIcon size="sm">
          <SvgArrowLinkRight />
        </P2GIcon>
      }
    >
      {labelText}
    </P2GButton>
  );
}
